import { render, staticRenderFns } from "./AsignacionLoteTranspForm.vue?vue&type=template&id=184a476c&scoped=true&"
import script from "./AsignacionLoteTranspForm.vue?vue&type=script&lang=js&"
export * from "./AsignacionLoteTranspForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184a476c",
  null
  
)

/* custom blocks */
import block0 from "./AsignacionLoteTranspForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VFlex,VIcon,VLayout,VListItem})
